import classnames from "classnames";
import styles from "../styles/search.module.scss";
import { Box, Button } from "@mui/material";
import { useState } from "react";
import { Icon, IconButton } from "ui";
import PropTypes from "prop-types";

export function SearchBar() {
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");

  return (
    <Box className={styles.container}>
      <Box className={styles.search}>
        <Icon name="search" />
        <input
          name="search"
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Buscar cuento"
          type="text"
          value={search}
        />
      </Box>
      <Box className={styles.filter}>
        {[
          ["all", "Todos"],
          ["favorite", "Favoritos"],
          ["recent", "Recientes"],
        ].map(([value, label]) => (
          <Button
            key={value}
            className={classnames({
              [styles.active]: filter === value,
            })}
            onClick={() => setFilter(value)}
          >
            {label}
          </Button>
        ))}
        <Box className={styles.group}>
          <IconButton icon="grid_view" />
          <IconButton icon="info" />
        </Box>
      </Box>
    </Box>
  );
}

SearchBar.propTypes = {
  onSearch: PropTypes.func,
  onFilter: PropTypes.func,
};
